import { Routes } from '@angular/router';
import { RoleGuard } from '@shared/guards/role.guard';

export const routesMaintance: Routes = [
  {
    path: '1009',
    data: { breadcrumb: '1009' },
    loadComponent: () =>
      import('./maintenance-categories/maintenance-categories.component').then(
        (m) => m.MaintenanceCategoriesComponent
      ),
      canActivate: [RoleGuard],
  },
  {
    path: '1010',
    data: { breadcrumb: '1010' },
    loadComponent: () =>
      import(
        './maintenance-subcategories/maintenance-subcategories.component'
      ).then((m) => m.MaintenanceSubcategoriesComponent),
      canActivate: [RoleGuard],
  },
  {
    path: '1011',
    data: { breadcrumb: '1011' },
    loadComponent: () =>
      import('./maintenance-messages/maintenance-messages.component').then(
        (m) => m.MaintenanceMessagesComponent
      ),
    canActivate: [RoleGuard],
  },
  {
    path: '1012/maintenance-users',
    data: { breadcrumb: '1012' },
    loadComponent: () =>
      import('./maintenance-users/maintenance-users.component').then(
        (m) => m.MaintenanceUsersComponent
      ),
    canActivate: [RoleGuard],
  },
  {
    path: '1012/maintenance-systemid',
    data: { breadcrumb: '1012' },
    loadComponent: () =>
      import('./maintenance-systemid/maintenance-systemid.component').then(
        (m) => m.MaintenanceSystemidComponent
      ),
    canActivate: [RoleGuard],
  },
  {
    path: '1030',
    data: { breadcrumb: '1030' },
    children: [
      {
        path: '',
        data: {
          breadcrumb: 'Logs finacle',
        },
        loadComponent: () =>
          import(
            './maintenance-log-finacle/maintenance-log-finacle.component'
          ).then((m) => m.MaintenanceLogFinacleComponent),
      },
      {
        path: ':idLog',
        data: { breadcrumb: 'Detalle' },
        loadComponent: () =>
          import(
            './maintenance-log-finacle-detail/maintenance-log-finacle-detail.component'
          ).then((m) => m.MaintenanceLogFinacleDetailComponent),
      },
    ],
    canActivate: [RoleGuard],
  },
  {
    path: '1032',
    data: { breadcrumb: '1032' },
    children: [
      {
        path: '',
        data: {
          breadcrumb:
            'Mantenimiento de áreas, prioridades y mensajes de gestión',
        },
        loadComponent: () =>
          import(
            './maintenance-areas-priorities-management-messages/maintenance-areas-priorities-management-messages.component'
          ).then(
            (m) => m.MaintenanceAreasPrioritiesManagementMessagesComponent
          ),
      },
      {
      path: ':areaCode/categories',
      data: { breadcrumb: 'Categorías' },
      loadComponent: () =>
        import(
          './maintenance-areas-priorities-management-messages/maintenance-priorities/maintenance-priorities.component'
        ).then((m) => m.MaintenancePrioritiesComponent),
      },
      {
      path: ':areaCode/categories/:categoryCode/subcategories',
      data: { breadcrumb: 'Subcategorías' },
      loadComponent: () =>
        import(
          './maintenance-areas-priorities-management-messages/maintenance-management-messages/maintenance-management-messages.component'
        ).then((m) => m.MaintenanceManagementMessagesComponent),
      },
      {
        path: 'maintenance-1032-crud/:action/:areaCode',
        data: { breadcrumb: 'Prioridades' },
        loadComponent: () =>
          import(
            './maintenance-areas-priorities-management-messages/maintenance-1032-crud/maintenance-1032-crud.component'
          ).then((m) => m.Maintenance1032CrudComponent),
      },
      {
        path: 'maintenance-1032-crud/:action/:areaCode/:categoryCode/:subCategoryCode',
        data: { breadcrumb: 'crud' },
        loadComponent: () =>
          import(
            './maintenance-areas-priorities-management-messages/maintenance-1032-crud/maintenance-1032-crud.component'
          ).then((m) => m.Maintenance1032CrudComponent),
      },
    ],
    canActivate: [RoleGuard],
  },
  {
    path: '1040',
    data: { breadcrumb: '1040' },
    children: [
      {
        path: 'tabla',
        data: { breadcrumb: 'Parámetros' },
        loadComponent: () =>
          import(
            './maintenance-general-parameters/main/table/bvcotrpar1040.component'
          ),
      },
      {
        path: 'crud',
        data: { breadcrumb: 'Parámetros' },
        loadComponent: () =>
          import(
            './maintenance-general-parameters/main/crud/bvcotrparCrud.component'
          ),
      },
      {
        path: 'crud/:action/:code',
        data: { breadcrumb: 'Parámetros' },
        loadComponent: () =>
          import(
            './maintenance-general-parameters/main/crud/bvcotrparCrud.component'
          ),
      },
      {
        path: 'sub-table/:code',
        data: { breadcrumb: 'Valores' },
        loadComponent: () =>
          import(
            './maintenance-general-parameters/sub-component/table/bvcotrpar1040Sub.component'
          ),
      },
      {
        path: 'sub-table/crud/:code',
        data: { breadcrumb: 'Valores' },
        loadComponent: () =>
          import(
            './maintenance-general-parameters/sub-component/crud/bvcotrpaSubCrud.component'
          ),
      },
      {
        path: 'sub-table/crud/:action/:code/:subCode',
        data: { breadcrumb: 'Valores' },
        loadComponent: () =>
          import(
            './maintenance-general-parameters/sub-component/crud/bvcotrpaSubCrud.component'
          ),
      },
      {
        path: 'log/:code',
        data: { breadcrumb: 'logs' },
        loadComponent: () =>
          import(
            './maintenance-general-parameters/logs/table/bvcotrpar1040LogsTable.component'
          ),
      },
      {
        path: 'log/:code/:id',
        data: { breadcrumb: 'logs' },
        loadComponent: () =>
          import(
            './maintenance-general-parameters/logs/detail/bvcotrpar1040LogsDetail.component'
          ),
      },
      {
        path: '**',
        redirectTo: 'tabla',
      },
    ],
    canActivate: [RoleGuard],
  },
];
